/**
 * Waiting for Approval Page
 * Shown to users who haven't been approved by admin yet
 */
export function WaitingForApprovalPage({ currentUser }) {
  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #ffffff 0%, #0f1f35 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '24px',
      direction: 'rtl',
    }}>
      <div style={{
        maxWidth: 600,
        width: '100%',
        background: '#ffffff',
        border: '2px solid #f59e0b44',
        borderRadius: 20,
        padding: 48,
        textAlign: 'center',
      }}>
        {/* Icon */}
        <div style={{
          width: 80,
          height: 80,
          borderRadius: '50%',
          background: 'linear-gradient(135deg, #f59e0b22, #f59e0b11)',
          border: '2px solid #f59e0b44',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 24px',
        }}>
          <span style={{ fontSize: 40 }}>⏳</span>
        </div>

        {/* Title */}
        <h1 style={{
          color: '#000000',
          fontSize: 28,
          fontWeight: 900,
          marginBottom: 16,
        }}>
          مرحباً {currentUser?.name}!
        </h1>

        {/* Message */}
        <p style={{
          color: '#000000',
          fontSize: 16,
          lineHeight: 1.8,
          marginBottom: 32,
        }}>
          تم تسجيل حسابك بنجاح
          <br />
          <span style={{ color: '#60a5fa', fontWeight: 700 }}>الخطوة الأولى:</span> أكمل التدريب المطلوب
          <br />
          <span style={{ color: '#60a5fa', fontWeight: 700 }}>الخطوة الثانية:</span> سيتم مراجعة تقدمك من المدير
          <br />
          <span style={{ color: '#10b981', fontWeight: 700 }}>الخطوة الثالثة:</span> ابدأ العمل واكسب العمولات! 🎉
        </p>

        {/* What happens next */}
        <div style={{
          background: '#ffffff',
          border: '1px solid #e2e8f0',
          borderRadius: 12,
          padding: 24,
          marginBottom: 32,
          textAlign: 'right',
        }}>
          <h3 style={{
            color: '#000000',
            fontSize: 18,
            fontWeight: 700,
            marginBottom: 16,
          }}>
            📋 خطوات البدء في العمل:
          </h3>
          <ul style={{
            color: '#000000',
            fontSize: 14,
            lineHeight: 2,
            margin: 0,
            paddingRight: 20,
          }}>
            <li>أكمل جميع مواد التدريب بالترتيب</li>
            <li>اضغط على "جاهز للمكالمات" عند الانتهاء</li>
            <li>سيراجع المدير تقدمك ويعتمد حسابك</li>
            <li>بعد الاعتماد، ستتمكن من الوصول لجهات الاتصال والعمل عليها</li>
            <li>ابدأ في حجز المطاعم واكسب العمولات! 💰</li>
          </ul>
        </div>

        {/* Info box */}
        <div style={{
          background: '#f59e0b11',
          border: '1px solid #f59e0b44',
          borderRadius: 8,
          padding: 16,
          marginBottom: 24,
        }}>
          <p style={{
            color: '#fcd34d',
            fontSize: 13,
            margin: 0,
          }}>
            💡 <strong>نصيحة:</strong> أثناء انتظار الاعتماد، يمكنك البدء بالتدريب الآن!
          </p>
        </div>

        {/* Go to Learning button */}
        <button
          onClick={() => window.location.href = `/${currentUser?.role}/learning`}
          style={{
            width: '100%',
            padding: '16px 24px',
            background: 'linear-gradient(135deg, #4ecdc4, #38b2ac)',
            border: 'none',
            borderRadius: 12,
            color: '#fff',
            fontSize: 18,
            fontWeight: 900,
            cursor: 'pointer',
            fontFamily: "'Cairo', sans-serif",
            marginBottom: 16,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 8,
          }}
        >
          📚 ابدأ التدريب الآن
        </button>

        {/* User info */}
        <div style={{
          background: '#ffffff',
          border: '1px solid #e2e8f0',
          borderRadius: 8,
          padding: 16,
        }}>
          <div style={{ color: '#64748b', fontSize: 12, marginBottom: 8 }}>معلومات حسابك:</div>
          <div style={{ color: '#000000', fontSize: 14, fontWeight: 700 }}>
            {currentUser?.name}
          </div>
          <div style={{ color: '#60a5fa', fontSize: 13, marginTop: 4 }}>
            {currentUser?.role === 'marketer' ? 'منسقة صفقات' : 
             currentUser?.role === 'rep' ? 'مندوب' : 
             currentUser?.role}
          </div>
        </div>
      </div>
    </div>
  );
}
